export default "Royal Escapes åbnede i maj 2021. De overtog lokalerne efter WayOut Copenhagen lukkede.";